import type { CookieNameDataType } from "./cookieNameTypes.ts";

export const getCookieName: CookieNameDataType = {
  currentBrand: "revmatics_current_brand",
  currentOrganization: "revmatics_current_org",
};
